import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createFile, editFile, showFile } from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { FileProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function File() {
  return (
    <FileProvider>
      <Switch>
        <Route
          exact
          path={createFile.spec}
          render={(props) => (
            <>
              <Can I="new" a="Files">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Files">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editFile.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Files">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Files">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showFile.spec}
          render={(props) => (
            <>
              <Can I="show" a="Files">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Files">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Files">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Files">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </FileProvider>
  );
}
export default File;
